// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDL2PCLzNHixeWw0xW_N8sfByfxpU4SJ2Y",
  authDomain: "petid-77a78.firebaseapp.com",
  projectId: "petid-77a78",
  storageBucket: "petid-77a78.firebasestorage.app",
  messagingSenderId: "953837832046",
  appId: "1:953837832046:web:9a047360cac568ea39a37f",
  measurementId: "G-V636DEE58H",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

export { app, analytics, auth, db, functions, storage };
